/* Domovoi · links inside the native app (D2.2). On the web, nothing.

   Capacitor's local server answers every folder address (/account/) with the
   app's index.html, the shell, so a plain link to a page lands back on the
   shell and looks like it did nothing. Here same-site links to folders are sent
   to the page's file instead (core/platform pageUrl), and, outside the shell
   (on the sign-in or account page), links to a product go back into the shell
   on that tab. Inside the shell, product links and sign-in/join are the
   shell's own (src/shell/main.js). */
import { isNative, pageUrl, statusBarText } from '../core/platform.js';

var PRODUCT = /^\/(catered|curated|considered|courted)(\/|$)/;

function onClick(e) {
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  var a = e.target.closest && e.target.closest('a[href]');
  if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
  var url = new URL(a.getAttribute('href'), location.href);
  if (url.origin !== location.origin) return;
  var path = url.pathname, inShell = document.documentElement.hasAttribute('data-shell');
  if (inShell && (path === '/' || PRODUCT.test(path) || /^\/(signin|join)(\/|$)/.test(path))) return;   // the shell's
  if (inShell && /^\/account(\/|$)/.test(path) && document.documentElement.hasAttribute('data-redesign')) return;   // the redesign's Account is the shell's too
  var to;
  if (path === '/' || path === '/index.html') to = '/shell.html';
  else if (PRODUCT.test(path)) to = '/shell.html?open=' + path + url.search;
  else if (/\/$/.test(path)) to = pageUrl(path + url.search + url.hash);
  if (!to) return;
  e.preventDefault();
  location.assign(to);
}

if (typeof document !== 'undefined' && isNative()) document.addEventListener('click', onClick);

/* No zooming in the app. iOS zooms in on any text field under 16px when you
   tap it and doesn't zoom back, which leaves the page wider than the screen
   and scrolling sideways (the sign-in page in TestFlight). An app page never
   needs pinch-zoom; the web keeps it. */
if (typeof document !== 'undefined' && isNative()) {
  var vp = document.querySelector('meta[name=viewport]');
  if (!vp) { vp = document.createElement('meta'); vp.name = 'viewport'; document.head.appendChild(vp); }
  vp.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover');
}

/* The app draws every page under the status bar (the shell pads its own
   header). The pages with the dark site nav (account, sign-in, join) get the
   same: the nav reaches up behind the time and battery, which turn white. */
function underStatusBar() {
  var root = document.documentElement;
  root.classList.add('dv-app');
  statusBarText(!root.hasAttribute('data-shell') && document.querySelector('.snav, .au-hero') ? 'light' : 'dark');
}
if (typeof document !== 'undefined' && isNative()) {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', underStatusBar); else underStatusBar();
}
